import { render, staticRenderFns } from "./pointList.vue?vue&type=template&id=d453e12a&scoped=true&"
import script from "./pointList.vue?vue&type=script&lang=js&"
export * from "./pointList.vue?vue&type=script&lang=js&"
import style0 from "./pointList.vue?vue&type=style&index=0&id=d453e12a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d453e12a",
  null
  
)

export default component.exports